import { resolveMediaUrl } from './mediaUrl';

export const parseSolutionsTailoredStrategiesContent = (page) => {
  if (!page?.sections?.length) {
    return null;
  }

  const section = page.sections.find((item) => item.key === 'tailored-strategies');
  if (!section) {
    return null;
  }

  const fields = section.fields || {};
  const featureImage =
    section.media?.primary ||
    section.media?.groups?.['feature-image']?.[0] ||
    null;
  const checkIcon = section.media?.groups?.['check-icon']?.[0] || null;

  if (!fields.title || !fields.text || !featureImage?.url || !checkIcon?.url) {
    return null;
  }

  const features = [];

  for (let index = 1; index <= 20; index += 1) {
    const feature = fields[`feature-${index}`];
    if (!feature) {
      break;
    }

    features.push(feature);
  }

  if (features.length === 0) {
    return null;
  }

  return {
    title: fields.title,
    text: fields.text,
    cta: {
      text: fields.ctaText || '',
      url: fields.ctaUrl || '',
    },
    features,
    featureImage: resolveMediaUrl(featureImage.url),
    checkIcon: resolveMediaUrl(checkIcon.url),
  };
};
